export const GEN_MENUS = 'GEN_MENUS';
export const GEN_ROUTES = 'GEN_ROUTES';

export const generateMenus = () => ({ type: GEN_MENUS })

export const generateRoutes = () => ({ type: GEN_ROUTES })